import { useSearchParams } from "react-router-dom";
import {
  SkirtingBoardsInstallationInformation,
  SkirtingBoardsMeasurementValues,
} from "./components";

interface SkirtingBoardsType {
  setStep: (page: number) => void;
  step: number;
  measurementInfo: any;
  prevStep: () => void;
}

const SkirtingBoards = ({
  step,
  setStep,
  measurementInfo,
  prevStep,
}: SkirtingBoardsType) => {
  const [searchParams] = useSearchParams();
  const measurementUuid = searchParams.get("measurementUuid");

  const handleShowForm = (step: number, measurementUuid: string | null) => {
    switch (step) {
      case 2:
        return (
          <SkirtingBoardsInstallationInformation
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <SkirtingBoardsMeasurementValues
            setStep={setStep}
            step={step}
            measurementInfo={measurementInfo}
            measurementUuid={measurementUuid}
            prevStep={prevStep}
          />
        );
      default:
        return <p>default</p>;
    }
  };

  return handleShowForm(step, measurementUuid);
};

export default SkirtingBoards;
